module.exports = __webpack_public_path__ + "static/media/pelota.3a16e16e.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/pelota/pelota.png
// module id = 331
// module chunks = 0